<nb-card>
  <nb-card-header>
    <div class="dialog-header">
      <h6>
        Lịch sử
        {{
          mode == "receive"
            ? "mua: " + purchaseDetail.productName
            : "bán: " + receiptDetail.productName
        }}
      </h6>
      <button
        class="cancel"
        nbButton
        outline
        status="info"
        size="small"
        (click)="cancel()"
      >
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>

    <table class="table table-sm table-borderless tbl-receipt-summary">
      <tr>
        <td class="col-label">{{ "receipt.quantity" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <nb-form-field fullWidth>
              <button
                nbPrefix
                nbButton
                ghost
                (click)="productQuantityIncrement(-1)"
              >
                <nb-icon icon="minus-circle-outline"> </nb-icon>
              </button>
              <input
                type="number"
                nbInput
                fullWidth
                shape="semi-round"
                class="form-control"
                placeholder="Nhập số lượng"
                [status]="quantity > 0 ? 'primary' : 'danger'"
                [(ngModel)]="quantity"
                (change)="summaryDetail()"
              />
              <button
                nbSuffix
                nbButton
                ghost
                (click)="productQuantityIncrement(1)"
              >
                <nb-icon icon="plus-circle-outline"> </nb-icon>
              </button>
            </nb-form-field>
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "receipt.price" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="Nhập giá bán"
              [status]="price > 0 ? 'primary' : 'danger'"
              [(ngModel)]="price"
              (change)="summaryDetail()"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </td>
      </tr>

      <tr>
        <td class="col-label">{{ "receipt.amount" | translate }}:</td>
        <td class="col-number">
          <h6 class="text-primary">{{ netAmount | number }}</h6>
        </td>
      </tr>

      <tr *ngIf="!(purchaseDetail && receiptDetail)">
        <td class="col-label">{{ "receipt.discount" | translate }}:</td>
        <td class="col-number">
          <div class="form-inline">
            <input
              type="number"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              style="width: 20px"
              min="0"
              max="100"
              placeholder="% ck"
              [(ngModel)]="discountPercent"
              (change)="summaryDetail()"
            />

            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="$ ck"
              [status]="discountAmount > 0 ? 'primary' : 'danger'"
              [(ngModel)]="discountAmount"
              (change)="onInputDiscountAmountChange()"
              (keydown.enter)="onInputDiscountAmountChange()"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </td>
      </tr>
      <tr>
        <td class="col-label">
          <h6 class="text-hint">{{ "receipt.total" | translate }}:</h6>
        </td>
        <td class="col-number">
          <h6 class="text-danger">
            {{ amount | number }}
          </h6>
        </td>
      </tr>

      <tr>
        <td colspan="2" class="col-label">
          <textarea
            nbInput
            fullWidth
            rows="2"
            placeholder="{{ 'receipt.inputNote' | translate }}"
            class="form-control"
            [(ngModel)]="comment"
          ></textarea>
        </td>
      </tr>
    </table>
  </nb-card-header>
  <nb-card-body>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ "common.date" | translate }}</th>
            <th scope="col" class="col-number-history">Số lượng</th>
            <th scope="col" class="col-number-history">
              {{ mode === "receive" ? "Giá mua" : "Giá bán" }}
            </th>
            <th scope="col" class="col-number-history">Thành tiền</th>
            <th scope="col" class="col-action"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of inventories | filter : strSearch; let i = index"
          >
            <td class="col-no">
              {{ i + 1 }}
            </td>
            <td>
              {{ item.issueDate | date : "dd/MM/yyyy" }}
            </td>

            <td class="col-number-history">
              {{
                (mode === "receive" ? item.receiveQuantity : item.issueQuantity)
                  | number
              }}
            </td>
            <td class="col-number-history">
              {{
                (mode === "receive" ? item.receivePrice : item.issuePrice)
                  | number
              }}
            </td>
            <td class="col-number-history">
              {{
                (mode === "receive" ? item.receiveAmount : item.issueAmount)
                  | number
              }}
            </td>

            <td class="col-action">
              <button
                nbButton
                ghost
                shape="round"
                status="success"
                (click)="selectedLastPrice(item)"
              >
                <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="primary"
      size="small"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
